import { Link } from 'react-router-dom';

import Container from '../components/Container';

export default function NotFound() {
  return (
    <Container narrow>
      <div className="djinn-card p-10 text-center">
        <p className="text-sm font-semibold uppercase tracking-widest text-djinn-text-muted">
          404
        </p>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight text-djinn-text">
          Page not found
        </h1>
        <p className="mt-3 text-djinn-text-2">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="djinn-btn-primary mt-6">
          Back home
        </Link>
      </div>
    </Container>
  );
}
